<template>
  <div class="form__selectDateWrapper mt-6">
    <h4 v-if="label" class="mb-0">{{ label }}</h4>

    <v-row align="center" ref="selectDateWrapper">
      <v-col
        class="text-center"
        v-for="(time, index) in preferredHours"
        :key="index"
      >
        <div class="form__customCheck">
          <input
            type="radio"
            name="hourSelect"
            :id="`hour-${index}`"
            :value="time"
            :disabled="disableAllHours"
          />
          <label
            :for="`hour-${index}`"
            :class="`${isTimeInvalid || disableAllHours ? 'invalid' : ''}`"
            @click="setPreferredTime(time, isTimeInvalid)"
          >
            {{ time }}
            <v-icon v-if="isTimeInvalid" x-small>mdi-close</v-icon>
            <v-icon v-else x-small>mdi-check</v-icon>
          </label>
        </div>
      </v-col>
      <v-col>
        <v-select
          class="form__customCheckSelect"
          @change="setCustomTime"
          :items="customHours"
          v-model="selectedTime"
          :label="moreOptionsLabel"
          :disabled="disableAllHours"
          outlined
          dense
        >
          <v-icon x-small>mdi-check</v-icon>
        </v-select>
      </v-col>
    </v-row>

    <VMessages
      :value="errorBucket"
      color="error"
      v-if="validationState && !dateTimeMode"
    />

    <p
      v-if="isTimeInvalid"
      class="form__selectTimeError error--text caption mb-0"
    >
      {{ $t('forms.timesGone') }}
    </p>
  </div>
</template>

<script>
import VInput from 'vuetify/lib/components/VInput/VInput.js'
import moment from 'moment'

export default {
  name: 'HTimePicker',

  extends: VInput,

  props: {
    value: {
      type: String,
    },

    dateTimeMode: {
      type: Boolean,
      default: false,
    },

    isToday: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      disableAllHours: true,
      selectedTime: null,
      isTimeInvalid: false,
      moreOptionsLabel: this.$t('filters.datePicker.more'),
      preferredHours: ['08:30', '10:00', '14:00', '16:00'],
      customHours: [],
    }
  },

  mounted() {
    this.$nextTick(function() {
      this.generateCustomHours()
    })
  },

  watch: {
    isToday() {
      this.generateCustomHours()
    },
  },

  methods: {
    resetCustomSelect() {
      if (!this.disableAllHours) {
        const inputs = this.$refs.selectDateWrapper.querySelectorAll('input')

        inputs.forEach((item) => {
          item.checked = false
          item.disabled = false
          item.nextSibling && item.nextSibling.classList.remove('invalid')

          this.$nextTick(() => {
            if (this.isToday && !this.checkPreferredHours(item.value)) {
              item.disabled = true
              item.nextSibling && item.nextSibling.classList.add('invalid')
            }
          })
        })
      }
    },

    setPreferredTime(value) {
      if (this.isToday && !this.checkPreferredHours(value)) return

      this.selectedTime = null
      this.isTimeInvalid = false
      this.$emit('input', value)
    },

    setCustomTime() {
      this.isTimeInvalid = false
      this.$emit('input', this.selectedTime)
      this.resetCustomSelect()
    },

    generateCustomHours() {
      const startTime = 7
      const endTime = 22
      const currentHour = moment().format('HH:mm')

      this.customHours = []

      for (let i = 0; i <= 1440; i += 15) {
        let hours = Math.floor(i / 60)
        let minutes = i % 60
        let hourMinute = null

        hours = hours % 24
        minutes < 10 ? (minutes = `0${minutes}`) : minutes
        hourMinute = `${hours}:${minutes}`

        if (
          moment(hourMinute, 'hh:mm').isBetween(
            moment(this.isToday ? currentHour : startTime, 'hh:mm'),
            moment(endTime, 'hh:mm')
          )
        ) {
          this.customHours.push(hours + ':' + minutes + ' ')
        }
      }
    },

    checkPreferredHours(hour) {
      const currentHour = moment()
      const receivedHour = moment(hour, 'hh:mm')
      return receivedHour.isAfter(currentHour)
    },

    resetValue() {
      this.selectedTime = null
      this.resetCustomSelect()
    },
  },
}
</script>
